import React from 'react';
import { PayPalMessages as PayPalMessagesComponent } from '@secretescapes/cauldron';
import { useApplicationState } from '@utils/useApplicationState';
import useConfig from '@utils/useConfig';
import { PayPalMessagesProps } from './PayPalMessages.interfaces';
import { PayPalMessagesWrapper } from './PayPalMessages.styles';

export const PayPalMessages = ({ textSize, isMobile }: PayPalMessagesProps) => {
  const config = useConfig();
  const { territoryCode, currency } = useApplicationState();

  const paypalClientIds: Record<string, string | undefined> = {
    UK: config.app.PAYPAL_CLIENT_ID_UK,
    DE: config.app.PAYPAL_CLIENT_ID_DE,
  };

  const paypalClientId: string | undefined = paypalClientIds[territoryCode];

  const payPalComponent = (
    <PayPalMessagesComponent
      currency={currency}
      textSize={textSize}
      payPalClientId={paypalClientId}
      showLogo={true}
    />
  );

  return isMobile ? (
    <PayPalMessagesWrapper>{payPalComponent}</PayPalMessagesWrapper>
  ) : (
    payPalComponent
  );
};
